import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../../environments/environment';
import { AlgConsensoService } from '../../services/alg-consenso.service';

@Component({
  selector: 'alg-upload-document',
  templateUrl: './alg-upload-document.component.html',
  styleUrls: ['./alg-upload-document.component.scss'],
})
export class AlgUploadDocumentComponent implements OnInit {
  @Output() checkboxOutput = new EventEmitter<boolean>();
  @Output() uploadCompleted = new EventEmitter<boolean>();
  @Input() documentFolder: string;
  @Input() requestId: string;
  @Input() title: string;
  @Input() detailDocuments: string;z
  @Input() canUploadModuleDocument: boolean;
  @Input() canUploadFrontDocument: boolean;
  @Input() canUploadBackDocument: boolean;
  @Input() moduleAlias: string;
  @Input() frontDocumentAlias: string;
  @Input() backDocumentAlias: string;

  public uploaderModule: FileUploader;
  public uploaderFront: FileUploader;
  public uploaderBack: FileUploader;
  public controlCheckboxConsent: boolean;
  public uploadedDocumentModule: boolean;
  public uploadedDocumentFront: boolean;
  public uploadedDocumentBack: boolean;
  public fileFormatErrorModule: boolean;
  public fileFormatErrorFront: boolean;
  public fileFormatErrorBack: boolean;
  public fileUploadErrorModule: boolean;
  public fileUploadErrorFront: boolean;
  public fileUploadErrorBack: boolean;
  public overDropModule: boolean;
  public overDropFront: boolean;
  public overDropBack: boolean;

  constructor(private consensoService: AlgConsensoService) {}

  ngOnInit() {
    //const URL = `${environment.api.basePath}/upload--payment-method-document/${this.changePlan.requestId}`;
    const URL = `${environment.api.basePath}/${this.documentFolder}/${this.requestId}`;

    // Uploader module configuration
    this.uploaderModule = new FileUploader({
      url: URL,
      autoUpload: true,
      disableMultipart: false,
      itemAlias: this.moduleAlias,
    });
    // Rename file
    this.uploaderModule.onAfterAddingFile = (file) => {
      const timestamp = new Date().getTime();
      file.file.name = `${this.requestId}_${timestamp}`;
    };
    this.uploaderModule.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    // Check file upload status
    this.uploaderModule.onSuccessItem = (status) => {
      if (status.isSuccess) {
        this.uploadedDocumentModule = true;
        this.emitUploadCompleted();
        this.consensoService.uploaded104DocumentModule$.next(true);
      }
      if (status.isError) {
        this.fileUploadErrorModule = true;
        this.consensoService.uploaded104DocumentModule$.next(false);
      }
    };

    this.uploaderModule.onErrorItem = (status) => {
      if (status.isError) {
        this.fileUploadErrorModule = true;
        this.consensoService.uploaded104DocumentModule$.next(false);
      }
    };

    // Uploader Front configuration
    this.uploaderFront = new FileUploader({
      url: URL,
      autoUpload: true,
      disableMultipart: false,
      itemAlias: this.frontDocumentAlias,
    });
    // Rename file
    this.uploaderFront.onAfterAddingFile = (file) => {
      const timestamp = new Date().getTime();
      file.file.name = `${this.requestId}_${timestamp}`;
    };
    this.uploaderFront.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    // Check file upload status
    this.uploaderFront.onSuccessItem = (status) => {
      if (status.isSuccess) {
        this.uploadedDocumentFront = true;
        this.emitUploadCompleted();
        this.consensoService.uploaded104DocumentFront$.next(true);
      }
      if (status.isError) {
        this.fileUploadErrorFront = true;
        this.consensoService.uploaded104DocumentFront$.next(false);
      }
    };

    this.uploaderFront.onErrorItem = (status) => {
      if (status.isError) {
        this.fileUploadErrorFront = true;
        this.consensoService.uploaded104DocumentFront$.next(false);
      }
    };

    // Uploader Back configuration
    this.uploaderBack = new FileUploader({
      url: URL,
      disableMultipart: false,
      autoUpload: true,
      itemAlias: this.backDocumentAlias,
    });
    this.uploaderBack.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    // Rename file
    this.uploaderBack.onAfterAddingFile = (file) => {
      const timestamp = new Date().getTime();
      file.file.name = `${this.requestId}_${timestamp}`;
    };
    // Check file upload status
    this.uploaderBack.onSuccessItem = (status) => {
      if (status.isSuccess) {
        this.uploadedDocumentBack = true;
        this.emitUploadCompleted();
        this.consensoService.uploaded104DocumentBack$.next(true);
      }
      if (status.isError) {
        this.fileUploadErrorBack = true;
        this.consensoService.uploaded104DocumentBack$.next(false);
      }
    };
    this.uploaderBack.onErrorItem = (status) => {
      if (status.isError) {
        this.fileUploadErrorBack = true;
        this.consensoService.uploaded104DocumentBack$.next(false);
      }
    };
  }

  ngOnChanges() {}

  private emitUploadCompleted() {
    if (this.canUploadFrontDocument && !this.uploadedDocumentFront) return;
    if (this.canUploadBackDocument && !this.uploadedDocumentBack) return;
    if (this.canUploadModuleDocument && !this.uploadedDocumentModule) return;
    this.uploadCompleted.emit(true);
  }

  public droppedFile(event, type: string) {
    switch (type) {
      case 'module':
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.fileFormatErrorModule = false;
        } else {
          this.fileFormatErrorModule = true;
        }
        break;
      case 'front':
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.fileFormatErrorFront = false;
        } else {
          this.fileFormatErrorFront = true;
        }
        break;

      case 'back':
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.fileFormatErrorBack = false;
        } else {
          this.fileFormatErrorBack = true;
        }
        break;
    }
  }

  public fileOverBase(event, type: string) {
    switch (type) {
      case 'module':
        this.overDropModule = event;
        break;
      case 'front':
        this.overDropFront = event;
        break;
      case 'back':
        this.overDropBack = event;
    }
  }

  public uploadDocument(type: string) {
    switch (type) {
      case 'module':
        (<HTMLInputElement>document.getElementById('moduleDocument')).click();
        break;
      case 'front':
        (<HTMLInputElement>document.getElementById('frontDocument')).click();
        break;

      case 'back':
        (<HTMLInputElement>document.getElementById('backDocument')).click();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-upload-document/alg-upload-document.component.ts